import getLeadFormParamsByAppName from '../../TrimCardGrid/utils/getLeadFormParamsByAppName';
import useGetLinkSearchParams, { FEATURE_ORIGIN_BAP } from '../../TrimCardGrid/hooks/useGetLinkSearchParams';
import { BOOK_AN_APPOINTMENT_URL, CONTACT_DEALER_URL } from '../../../utils/constants';
import { selectDealer } from '../../../core/reducers/dealer';
import { useAppName, useSharedApps } from '../../../utils/sitecoreContext';
import { useAppSelector } from '../../../core/utils';
const useGetSummaryDealerLink = () => {
    const appName = useAppName();
    const { dealerCode } = useAppSelector(selectDealer);
    const dealerBaseUrl = useSharedApps(dealerCode ? CONTACT_DEALER_URL : BOOK_AN_APPOINTMENT_URL);
    const generatePayload = getLeadFormParamsByAppName(appName, FEATURE_ORIGIN_BAP);
    const dealerParamsString = useGetLinkSearchParams({ dealerCode, generatePayload });
    const dealerUrl = `${dealerBaseUrl}?${dealerParamsString}`;
    return dealerUrl;
};
export default useGetSummaryDealerLink;
